import type { JSX } from 'react';
import { generatePath } from 'react-router';

import { Link } from 'Components/Buttons/Buttons';
import { RBACComponent } from 'Components/Context/RBACComponent';
import { RiskTable } from 'Components/RiskRegister/RiskTable/RiskTable';
import { Text } from 'Components/Text/Text';
import { ICON_ADD_CREATE } from 'Config/Icons';
import { CREATE_RISK } from 'Config/PathTemplates';
import { RISK_ROLES } from 'Helpers/UserUtils';
import { RiskResponse } from 'Models/RiskRegister';
import { UserResponse } from 'Models/User';

import styles from './Risks.module.css';

export interface RisksProps {
    users: UserResponse[];
    risks: RiskResponse[];
    controlIdentifier: string;
}

export const Risks = (props: RisksProps): JSX.Element => {
    return (
        <>
            <div className={styles.header}>
                <Text color="blue" variant="Header2">
                    Risks Mitigated by Control
                </Text>
                <RBACComponent roles={RISK_ROLES}>
                    <Link variant="primaryButton" to={`${generatePath(CREATE_RISK)}?controlId=${encodeURIComponent(props.controlIdentifier)}`} fontAwesomeImage={ICON_ADD_CREATE}>
                        Add New
                    </Link>
                </RBACComponent>
            </div>
            <div className={styles.pageSection}>
                <RiskTable type="current risks" risks={props.risks} controlContext={props.controlIdentifier} />
            </div>
        </>
    );
};
